module.exports = __webpack_public_path__ + "img/Gruppe_für_soziale_Betreuung.d70e56df.svg";